const neonZoneData = {
  id: "neonzone",
  title: "Leon's Neon Zone",
  category: "Live Ops",
  slug: "events/neonzone",
  sections: [
    {
      id: "home",
      title: "Home",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "Leon's Neon Zone Guide",
          content: [
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avis/neonzone.jpg",
                alt: "Leon's Neon Zone Guide",
              },
            },
            {
              type: "text",
              data: `Welcome to the Guide for Leon's Neon Zone. While this isn't a temporary feature, I will still add it to the Live Ops Guides to provide in-depth information for each of the games.`,
            },
          ],
        },
      ],
    },
    {
      id: "how-to-play",
      title: "How to Participate",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "Zonez Tokens",
          content: [
            {
              type: "text",
              data: `Every game costs Zonez Tokens to play, for both ranked and unranked games. You can buy Zonez Tokens from the desk near Bart.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_164126350.png",
                alt: "Zonez Tokens Desk",
              },
            },
            {
              type: "text",
              data: `There's a limited amount of tokens you can buy with coins each day, but you can buy unlimited Tokens with $PIXEL each day. The store for tokens resets at 12 AM UTC each day so you can continue to buy more tokens with coins`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Stuff Stubs",
          content: [
            {
              type: "text",
              data: `When you win games, you receive Stuff Stubs as rewards. The rewards you receive vary based on how well you play each game. The better your score, the more Stuff Stubs you win. And if you lose, you receive no Stuff Stubs.`,
            },
            {
              type: "text",
              data: `<b>What to do with Stuff Stubs?</b> Stuff Stubs can be used to redeem prizes at the 3rd Dimension Redemption Store, or to spin the Vaporwheel of Fortune.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_165313533.png",
                alt: "Stuff Stubs Redemption Locations",
              },
            },
          ],
        },
        {
          type: "subdivision",
          title: "Ranked or Unranked",
          content: [
            {
              type: "text",
              data: `Every game except for <b>Higher Lower</b> has a ranked and unranked game mode. Ranked games count towards the leaderboards, while Unranked games only count towards milestones.
              <br/><br/>You have a limit of 7 (increased from 5) ranked games for each game every day. These reset at midnight UTC each day (this has been changed. Previously it was based on 24hours from your previous playtime). `,
            },
          ],
        },
      ],
    },
    {
      id: "veggievexer",
      title: "Veggie Vexer",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "How to Play",
          content: [
            {
              type: "text",
              data: `First click the Start button and decide whether or not you would like to play Ranked or Unranked. It's best to warm up with Unranked games, but remember every game costs 10 Tokens.
            <br/>There's 10 different fruits to try, and there can be duplicates ╰(￣ω￣ｏ)
            <br/>On the first rotation, try the first 4 fruits, or whichever 4 fruits you'd like to try and click <b>Try Code.</b>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_170915081.png",
                alt: "Veggie Vexer Round 1",
              },
            },
            {
              type: "text",
              data: `If a square is green, it means that's exactly where it should be.
              <br/>Yellow means the fruit is in the row, but in the wrong spot. 
              <br/>And no color means it doesn't belong at all
              <br/>After guessing every single possibility to determine the 4 squares, you can mix and put them in the right order.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_171438752.png",
                src: "Correct Solution for Veggie Vexer",
              },
            },
            {
              type: "text",
              data: `Once you've gotten it right, don't forget to claim your Stuff Stubs on the left side. You won't be able to play again until you claim the prize.`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Scoring",
          content: [
            {
              type: "text",
              data: `(●'◡'●) I don't have the list of all the rewards for each round, but if anyone has the missing info, please share!`,
            },
            {
              type: "table",
              data: [
                {
                  "Line Victory": "5th",
                  "Stuff Stubs": "334 Stubs",
                },
                {
                  "Line Victory": "4th",
                  "Stuff Stubs": "345 Stubs",
                },
                {
                  "Line Victory": "3rd",
                  "Stuff Stubs": "356 Stubs",
                },
                {
                  "Line Victory": "2nd",
                  "Stuff Stubs": "",
                },
                {
                  "Line Victory": "1st",
                  "Stuff Stubs": "",
                },
                {
                  "Line Victory": "None",
                  "Stuff Stubs": "0 Stubs",
                },
              ],
            },
          ],
        },
        {
          type: "subdivision",
          title: "Game Rules",
          content: [
            {
              type: "image",
              data: {
                img: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/o/obj_htp_mastermind/efbd267c-4ab7-49dc-a5ec-49bd7cf8ef3d.png?v6",
                alt: "Game Rules for Veggie Vexer",
              },
            },
          ],
        },
      ],
    },
    {
      id: "bunnybaiter",
      title: "Bunny Baiter",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "How to Play",
          content: [
            {
              type: "text",
              data: `Bunny Baiter is a game where you try to keep <b>positive</b> points by leaving Bunnies on the surface, and killing the Moles.
            <br/>You need to activate all the dirt holes. Once a hole has been activated, if you get rid of the animal, you can't activate it again
            <br/>-------
            <br/>There's <b>25 Holes</b> and there's a chance for almost all holes to be Moles, so there's some luck at play
            <br/>Playing with a pet that has some speed would be beneficial so you can reach the holes easily.
            <br/>-------
            <br/>Your score will be the sum of all the animals on the screen. Moles are negative points so it'll remove points from your final score`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_173138883.png",
                alt: "Bunny Baiter Board",
              },
            },
            {
              type: "list",
              data: `Green zeroes means I successfully got rid of moles (or a negative score).
              White Numbers means I never uncovered those holes.
              Red zeroes means I killed a bunny (or a positive score)
             Red Negative Numbers means a mole took away my score
              Green Positive Numbers means Bunnies added to my score`,
            },
            {
              type: "text",
              data: `When you add it all together, you'll see it adds up to the score of 13 (16 positive and -3 Negative).`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Scoring",
          content: [
            {
              type: "text",
              data: `You get 25 Stuff Stubs for each point you score. Your score is in the top left corner and is the sum of all the points on the board. 
              <br/>The maximum possibility a score can be is 75 (if you're lucky enough to have 3 Point Bunnies on each hole). 
              <br/>An average score of 25 is expected if you're decent at the game (or ~600 Stuff Stubs)`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_172616284.png",
                alt: "Bunny Baiter Score",
              },
            },
          ],
        },
        {
          type: "subdivision",
          title: "Game Rules",
          content: [
            {
              type: "image",
              data: {
                img: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/o/obj_htp_bunnybaiter/e21fafce-f463-447d-af58-7882aafc4451.png?v6",
                alt: "Game Rules for Bunny Baiter",
              },
            },
          ],
        },
      ],
    },
    {
      id: "squishthefish",
      title: "Squish The Fish",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "How to Play",
          content: [
            {
              type: "text",
              data: `Squish The Fish is a reskin of old games we've had in Pixels, like Heartbeet Hoedown and Bump-a-Grump. Essentially, you hit as many fish as you can before time runs out.
            <br/>Having a speed pet is somewhat beneficial. There's 14 holes and they're pretty close to each other so not that difficult to move around and click.
            <br/><br/>You have 45 seconds to squish fish. Once you click start, fish will start popping out from the holes and you just click them with your mouse or tap them on your phone.
            <br/>Gold fish are worth the most, and Brown-ish fish are worth the least, but it's worth to hit all of them.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_174338592.png",
                alt: "Squish the Fish Board",
              },
            },
          ],
        },
        {
          type: "subdivision",
          title: "Scoring",
          content: [
            {
              type: "text",
              data: `You get 3.5 Stuff Stubs per point. On average, I was able to score around 90 Points per game with no pet. With a pet, you can get up to 130 Points (or around 450 Stuff Stubs).`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Game Rules",
          content: [
            {
              type: "image",
              data: {
                img: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/o/obj_htp_squishthefish/17d401b3-69a8-4504-80d2-76d03c0fe105.png?v6",
                alt: "Squish the Fish Game Rules",
              },
            },
          ],
        },
      ],
    },
    {
      id: "shutthebox",
      title: "Shut The Box",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "How to Play",
          content: [
            {
              type: "text",
              data: `One of the harder games of the four leaderboard games, Shut The Box is very hard to win against the dealer. If you've never played before, you should definitely play Unranked until you understand the game.`,
            },
            {
              type: "text",
              data: `<b>How To Play:</b> Start the game by clicking on the die. Choose Ranked or Unranked and pay your tokens. There's no timer so you are not rushed.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_174951499.png",
                alt: "Click to Start Shut the Box",
              },
            },
            {
              type: "text",
              data: `Roll the Die, and the number that pops up on the die (in the image below it's a sum of 3) is the number you'll pick for boxes. Since I have never selected 3 before, I will pick the #3 Box.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_175116021.png",
                alt: "Sum the Die and pick a number that matches",
              },
            },
            {
              type: "text",
              data: `I can only choose a box one time per game, so I need to be careful. 
              <br/>Roll the dice again. I can keep rolling the dice until I am out of boxes to choose.`,
            },
            {
              type: "gallery",
              images: [
                {
                  src: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_175126089.png",
                  alt: "Roll a 9",
                },
                {
                  src: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_175137480.png",
                  alt: "Roll a 7",
                },
                {
                  src: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_175218694.png",
                  alt: "Roll an 11",
                },
              ],
            },
            {
              type: "text",
              data: `In the example below, I roll a 9 again. But I rolled a 9 earlier, so I already chose the 9 box. Now I must pick boxes that add up to 9 like (5 and 4) or (8 and 1)`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_175302537.png",
                alt: "Rolling a 9 again",
              },
            },
            {
              type: "text",
              data: `Now I roll again, but I get a 3. Since I have no way to select 3 (2 and 1 are gone, and 3 is gone) I can no longer play and it's the Dealer's turn<br/>
              <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_175319309.png" alt="Losing my turn" class="h-90"/>
              <br/>If the dealer gets more than my score of 45, I lose. If the dealer gets less than 45 I win.`,
            },
            {
              type: "text",
              data: `All the boxes selected in Red are the ones the Dealer selected. When you add his numbers and my numbers, I have a higher score so I win.
              <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_180337953.png" alt="Dealer Loses" class="h-90"/>`,
            },
            {
              type: "text",
              data: `In this example, I lose because the Dealer has a higher score than I do. I got unlucky and rolled a 4 twice, but already used my 3. I had no other way to play a 4.
              <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_180601313.png" alt="Dealer Wins" class="h-90"/>`,
            },
            {
              type: "text",
              data: `Talk about a lucky board! I almost got all the boxes selected except for 12 q(≧▽≦q)
              <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_181022690.png" alt="Lucky Board" class="h-90"/>`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Scoring",
          content: [
            {
              type: "text",
              data: `The highest score you can get is 78 (which would be a full board). Since the update on October 6 2025, you can get Stuff Stubs even if you lose.<br/>
               The old scoring system was based on win, lose or draw. 500 Stuff Stubs (which was nerfed from 750 Stuff Stubs) for win. 150 Stuff Stubs for a draw. 0 Stuff Stubs for a Loss.<br/><br/>
               New Scoring System:
               <br/>🍃 150 Stuff Stubs for a Tie
               <br/>🥇 A victory always seems to score you over 300 Stuff Stubs with the lowest victory netting you 310 Stuff Stubs (1 Score Difference)
               <br/>🏆 The highest victory I've seen is 535 Stuff Stubs (22 Score Difference)
               <br/>🧨 145 Stuff Stubs for the highest loss (1 Score Difference)
               <br/>💣 The lowest I have seen is 4 Stuff Stubs for a 34 Score Difference`,
            },            
          ],
        },
        {
          type: "subdivision",
          title: "Game Rules",
          content: [
            {
              type: "image",
              data: {
                img: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/o/obj_htp_shutthebox/6b2e61a9-6dcb-4698-bc48-da1b6c023d40.png?v6",
                alt: `Game Rules for Shut The Box`,
              },
            },
          ],
        },
      ],
    },
    {
      id: "higherlower",
      title: "Higher Lower",
      type: "section",
      content: [
        {
          title: "How to Play",
          content: [
            {
              type: "text",
              data: `The objective of this game is to guess whether the next card will be higher, lower or equal. There's no ranked or unranked mode, so you just choose how much you are willing to risk, and risk it all.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_205819886.png",
                alt: "Pick Betting Amount",
              },
            },
            {
              type: "text",
              data: `After you've chosen an amount, you'll be presented with a card. The order of the cards from lowest to highest is:
              <br/> A - 2 - 3 - 4 - 5 - 6 - 7 - 8 - 9 - 10 - J - Q - K
              <br/><br/>There's 52 cards in the deck. So there's 4 of each card. There's a possibility of the same card popping up 5.88% of the time if the card deck hasn't been out of rotation yet.`,
            },{
              type: "text",
              data: `Keep the streak going by guessing correctly. If you feel like you don't stand a chance, claim your Riches or lose EVERYTHING.`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Game Rules",
          content: [
            {
              type: "image",
              data: {
                img: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/o/obj_htp_HLCard/b12df471-0296-40ed-be3e-a01ae6c8e95c.png?v6",
                alt: "Higher Lower Game Rules",
              },
            },
          ],
        },
      ],
    },{
      id: "mines",
      title: "Mines",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "How to Play",
          content: [
            {
              type: "text",
              data: `Objective: Cash Out before you lose all your stuff stubs!<br/><br/>
              First, choose your bet and how many mines you want in the game. You can have up to 24 Mines in the 25 square grid, and you can bet up to 10,000 Stuff Stubs.<br/>
              If you've never played before, it's best to start small! 1 Mine, 1000 (minimum) Stuff Stubs then click Start.`
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-10-10_172537486.png",
                alt: "Mines Bets and Number of Mines ",
              },
            },
            {
              type: "text",
              data: `Once you've clicked start, you can start selecting squares in the grid. Click squares and hope that they're $PIXEL squares. Keep selecting. The selection ENDS when you hit a mine (well it looks like a bomb).`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-10-10_173430843.png",
                src: "Mines playing until you hit a bomb",
              },
            },
            {
              type: "text",
              data: `I'm going to stop here and Claim My Riches! Then I'll go again. The higher my streak, the higher chance I'll get on the leaderboard.`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-10-10_173556165.png",
                src: "Mines hit a bomb",
              },
            },
          ],
        },
        {
          type: "subdivision",
          title: "Scoring",
          content: [
            {
              type: "text",
              data: `To score on the leaderboard, you need to get your streak higher. Your higher your streak, the more chance of landing on the top of the LB<br/>
              So claim your riches until you hit that bomb! If you take your time, there's a good chance you'll get pretty high.`,
            },            
          ],
        },
        {
          type: "subdivision",
          title: "Game Rules",
          content: [
            {
              type: "image",
              data: {
                img: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/o/obj_mines_htp/70cd29c7-2b92-4bc0-aa7d-c3452e388f45.png?v6",
                alt: "Game Rules for Mines",
              },
            },
          ],
        },
      ],
    },
    {
      id: "milestones-leaderboards",
      title: "Milestones & Leaderboards",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "Milestones",
          content: [
            {
              type: "text",
              data: `Each game has a Milestone Leaderboard. You rank up on this leaderboard whether you're playing Ranked or Unranked. 
          <br/>Inside each game room, you can click Milestones to see what the milestone rewards are. You receive these on the final day of the leaderboard (shows on the leaderboard)
          <br/>Every set of tokens you spend can earn you Stuff Stubs or Zonez Tokens. These are not based on how much points you win in the game, but on how much you spend!`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Leaderboards",
          content: [
            {
              type: "text",
              data: `There are two leaderboards for the games, with grand $PIXEL prizes. One leaderboard is for Higher Lower and the other leaderboard is for the other 4 games in rotation.`,
            },
            {
              type: "text",
              data: `Higher Lower Leaderboard depends on your HIGHEST score in Higher Lower. It is not a culmination of all your games, but your <b>best</b> game. So to rank on the Higher Lower leaderboard, you must have a single really good game.`,
            },
            {
              type: "text",
              data: `The other leaderboard is for a combination of your points scored across all the other games but only when you select Ranked. If you select Unranked as your game mode, the points do not add up on the board.
              <br/><br/>The points that are added is the total amount of stuff stubs you win in the game. Not the score itself. So the more stuff stubs you win, the better your points!`,
            },
          ],
        },
      ],
    },
    {
      id: "prizes",
      title: "Prize Redemption",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "3rd Dimension Redemption",
          content: [
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_204232305.png",
                alt: "3rd Dimension Redemption Shop",
              },
            },
            {
              type: "text",
              data: `The 3rd Dimension Redemption store is a shop where you can spend all your hard-earned stuff stubs. There are some costly rewards that are limited like Shoes, Neon Zone Aura, and will never return again.
              <br/>And there are other cool prizes like outfits, wallpaper, flooring and decor that are only available in this shop!`,
            },
            {
              type: "list",
              data: `Space Colony NFT House Skin (only 15)
              Water Spreader 1000 (New Water Sprinkler)
              Insanely Charming Crashed UFO (discoverability points that lasts 7 days)
              Auras (limited)
              Paintings (Rotating)
              Window Decor (Rotating)
              Avatar Outfits (Rotating)
              Outdoor & Indoor Decor (Rotating)`
            }
          ],
        },
        {
          type: "subdivision",
          title: "New Zeller",
          content: [
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_202039501.png",
                alt: "Zeller",
              },
            },            
            {
              type: "text",
              data: `The Zeller is a gacha-style prize redemption machine. It accepts both Divining Doubloons and Stuff Stubs. In the new Zeller, you'll always receive a prize. See the list below for the possible prizes from the Zeller.`,
            },
            {
              type: "list",
              data: `+1 Reputation
              Plushie Box (Margaret or Barney Plushie)
              Farm Toolbox (Combine Harvester or Gumball Machine)
              Decor Pack (Neon Chest, Speck House Skin, and other possible decor)
              Money Pouch ($PIXEL, Zones Tokens, Stuff Stubs or Coins)
              Random NFT Box (20 boxes - each with an avatar NFT)
              Animal Crate (Slugs, Chickens, Bees, Pet Coupons - only the leftover pets from the previous Zeller)`,
            },
          ],
        },
        {
          type: "subdivision",
          title: "Vaporwheel of Fortune",
          content: [
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_191726347.png",
                alt: "Vaporwheel of Fortune",
              },
            },
            {
              type: "text",
              data: `As of the latest update (Sept 15 2025), the Vaporwheel of Fortune is no longer an element of the Leon's Neon Zone Arcade.
              
              <br/><br/>The Vaporwheel of Fortune was a gacha-style prize pool. The types of rewards you could win varied, and were all based on luck.
              <br/>This is the only place to get the <b>Divining Doubloon</b> which can be used at Zeller.
              <br/><br/>To roll the Vaporwheel, you need 1,500 Stuff Stubs. Why would you want to do this? Mostly to get those tasty Divining Doubloons!
              <br/>Here's a list of things you can win from the Vaporwheel of Fortune:`,
            },
            {
              type: "list",
              data: `Zonez Packs
              Quicksilver
              Stuff Stubs
              Divining Doubloon Tokens
              Tic-Tac-Toe Tile
              EXP Crates
              Collectible Ducks (7 Ducks)
              Collectible Bears (6 Bears)`,
            },
          ],
        },        
        {
          type: "subdivision",
          title: "Old Zeller",
          content: [
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LeonsNeonZone/image_2025-08-17_202039501.png",
                alt: "Zeller",
              },
            },            
            {
              type: "text",
              data: `As of the latest update (September 15 2025) the Zeller has been changed. Please check out the New Zeller tab for latest information!<br/><br/>
              
              The Zeller is another gacha-style prize redemption but the only way to gain a chance is to get a Divining Doubloon from the Vaporwheel of Fortune.<br/>
              Use the Doubloon on Zeller and let him read your fortune! You might win prizes, and you might get nothing <(＿　＿)>`,
            },
            {
              type: "list",
              data: `+1 Reputation
              Chicken (No Limit)
              Slug (No Limit)
              Queen Bee (No Limit)
              Dash-O-Matic 1000 (?)
              Dash-O-Matic 2000 (?)
              Dash-O-Matic 3000 (5)
              Turkey (45)
              Sheep (45)
              T4 Winery (5)
              RoboPets (with 30 Stats) (20)`,
            },
          ],
        },
      ],
    },
  ],
};

export default neonZoneData;
